module.exports = __webpack_public_path__ + "img/map-big.c52284b5.png";